import {
  formatDate,
  BaseTransaction,
  formatBalance,
  BaseellaStatusTitle,
  Currency,
} from '@ui/src';
import getGeneralLedgerStatusTitle from '../../general-ledger/helpers/get-gl-enum-names';
import { PaymentType } from '../../../store/types';

import cn from '../../incoming/styles.module.css';

const formatNostroList = ({
  list,
  currenciesList,
  paymentTypes,
}: {
  list: BaseTransaction[];
  currenciesList?: Currency[];
  paymentTypes?: PaymentType[];
}): BaseTransaction[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    const currentCurrency = currenciesList?.find(
      (currency) => currency?.id === result?.currencyId,
    );

    const currentPaymentType = paymentTypes?.find(
      (type) => type.paymentType === item.paymentType,
    );

    const render: Record<string, any> = {
      transferDate: <div>{formatDate(result?.transferDate || '', true)}</div>,
      acceptedOut: <div>{formatDate(result?.acceptedOut || '')}</div>,
      acceptedIn: <div>{formatDate(result?.acceptedIn || '')}</div>,
      currencyId: <div>{result?.currency?.name || ''}</div>,
      recipientAccountNumber: result?.recipientAccount ? (
        <>
          <div>{result?.recipientAccount?.description}</div>
          <div className={cn.accNumber}>
            {result?.recipientAccount?.fullNumber}
          </div>
        </>
      ) : (
        result.recipientAccountNumber
      ),
      senderAccountNumber: result?.senderAccount ? (
        <>
          <div>{result?.senderAccount?.description}</div>
          <div className={cn.accNumber}>
            {result?.senderAccount?.fullNumber}
          </div>
        </>
      ) : (
        result.senderAccountNumber
      ),
      sum: <div>{formatBalance(result.sum, currentCurrency)}</div>,
      paymentType: <div>{currentPaymentType?.name}</div>,
      baseellaStatus: <div>{BaseellaStatusTitle[result.baseellaStatus]}</div>,
      documentNumber: (
        <div className={`${cn.documentNumberRow} ${cn.documentInfoRow}`}>
          {result.documentNumber}
        </div>
      ),
      info: <div className={cn.documentInfoRow}>{result.info}</div>,
    };

    result.render = render;

    const nextResult = {
      ...result,
      values:
        result.generalLedgerTransactions?.edges.map((el) => {
          const gl = el.node;

          const glCurrency = currenciesList?.find(
            (currency) => currency?.id === gl?.currencyId,
          );

          return {
            ...gl,
            render: {
              transferDate: (
                <div>{formatDate(gl?.transferDate || '', true)}</div>
              ),
              currencyId: <div>{gl?.currency.name || ''}</div>,
              debitAccountId: <div>{gl?.debitAccount?.fullNumber || ''}</div>,
              creditAccountId: <div>{gl?.creditAccount?.fullNumber || ''}</div>,
              debitAccount: <div>{gl?.debitAccount?.description || ''}</div>,
              creditAccount: <div>{gl?.creditAccount?.description || ''}</div>,
              sum: <div>{formatBalance(gl.sum, glCurrency)}</div>,
              status: (
                <div>{getGeneralLedgerStatusTitle(gl?.status || '')}</div>
              ),
            },
          };
        }) || [],
    };

    return nextResult;
  });

  return nextList;
};

export default formatNostroList;
